import React, { useState } from 'react';

const AchievementsCard = ({ achievements }) => {
  const [showAll, setShowAll] = useState(false);
  
  if (!achievements) {
    return (
      <div className="gamification-card">
        <div className="card-header">
          <h3 className="card-title">
            <i className="las la-trophy"></i>
            Conquistas
          </h3>
        </div>
        <div className="loading-container" style={{ padding: '2rem' }}>
          <div className="loading-text">Carregando conquistas...</div>
        </div>
      </div>
    );
  }

  const { unlocked = [], locked = [], unlocked_count = 0, total_available = 0 } = achievements;
  
  const getDisplayAchievements = () => {
    const allAchievements = [...unlocked, ...locked];
    return showAll ? allAchievements : allAchievements.slice(0, 6);
  };

  const getCategoryIcon = (category) => {
    switch (category) {
      case 'training': return 'las la-play-circle';
      case 'agent': return 'las la-robot';
      case 'marketplace': return 'las la-store';
      case 'milestone': return 'las la-flag-checkered';
      default: return 'las la-star';
    }
  };

  const formatProgress = (achievement) => {
    if (!achievement.progress) return null;
    
    const progress = achievement.progress.action_count;
    if (!progress) return null;
    
    return {
      current: progress.current || 0,
      required: progress.required || 1,
      percentage: progress.percentage || 0
    };
  };

  return (
    <div className="gamification-card">
      <div className="card-header">
        <h3 className="card-title">
          <i className="las la-trophy"></i>
          Conquistas
        </h3>
        <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>
          {unlocked_count} de {total_available} desbloqueadas
        </div>
      </div>

      {/* Estatísticas */}
      <div className="stats-grid" style={{ gridTemplateColumns: 'repeat(3, 1fr)', marginBottom: '1rem' }}>
        <div className="stat-item">
          <div className="stat-value" style={{ color: 'var(--success)' }}>
            {unlocked_count}
          </div>
          <div className="stat-label">Desbloqueadas</div>
        </div>
        
        <div className="stat-item">
          <div className="stat-value" style={{ color: 'var(--warning)' }}>
            {locked.length}
          </div>
          <div className="stat-label">Bloqueadas</div>
        </div>
        
        <div className="stat-item">
          <div className="stat-value" style={{ color: 'var(--primary)' }}>
            {total_available > 0 ? Math.round((unlocked_count / total_available) * 100) : 0}%
          </div>
          <div className="stat-label">Progresso</div>
        </div>
      </div>

      {/* Lista de conquistas */}
      <div className="achievements-grid">
        {getDisplayAchievements().map((achievement, index) => {
          const progress = formatProgress(achievement);
          const isUnlocked = achievement.status === 'unlocked';
          
          return (
            <div 
              key={achievement.id} 
              className={`achievement-card ${isUnlocked ? 'unlocked' : 'locked'} animate-in`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="achievement-header">
                <div className="achievement-icon">
                  <i className={getCategoryIcon(achievement.category)}></i>
                </div>
                <div className="achievement-info">
                  <h4>{achievement.name}</h4>
                  <p className="achievement-description">
                    {achievement.description}
                  </p>
                </div>
              </div>
              
              <div className="achievement-reward">
                <i className="las la-star"></i>
                <span>{achievement.xp_reward} XP</span>
              </div>
              
              {progress && !isUnlocked && (
                <div className="achievement-progress">
                  <div className="progress-header">
                    <span className="progress-label">Progresso</span>
                    <span className="progress-value">
                      {progress.current} / {progress.required}
                    </span>
                  </div>
                  <div className="progress-bar">
                    <div 
                      className="progress-fill" 
                      style={{ width: `${Math.min(progress.percentage, 100)}%` }}
                    ></div>
                  </div>
                </div>
              )}

              {isUnlocked && achievement.unlocked_at && (
                <div style={{ 
                  fontSize: '0.7rem', 
                  color: 'var(--success)', 
                  marginTop: '0.5rem',
                  textAlign: 'center'
                }}>
                  <i className="las la-check-circle"></i>
                  <span className="ms-1">
                    Desbloqueada em {new Date(achievement.unlocked_at).toLocaleDateString('pt-BR')}
                  </span>
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Botão Ver Mais */}
      {(unlocked.length + locked.length) > 6 && (
        <div style={{ textAlign: 'center', marginTop: '1rem' }}>
          <button
            onClick={() => setShowAll(!showAll)}
            className="btn btn-outline-primary btn-sm"
            style={{ minWidth: '120px' }}
          >
            {showAll ? (
              <>
                <i className="las la-chevron-up me-1"></i>
                Ver Menos
              </>
            ) : (
              <>
                <i className="las la-chevron-down me-1"></i>
                Ver Todas ({(unlocked.length + locked.length) - 6} restantes)
              </>
            )}
          </button>
        </div>
      )}

      {/* Dica */}
      <div style={{ 
        marginTop: '1rem', 
        padding: '0.75rem', 
        background: 'var(--info-50)', 
        borderRadius: '8px',
        fontSize: '0.8rem',
        color: 'var(--info)'
      }}>
        <i className="las la-lightbulb me-1"></i>
        <strong>Dica:</strong> Complete treinamentos, crie agentes e seja ativo na plataforma para desbloquear mais conquistas!
      </div>
    </div>
  );
};

export default AchievementsCard;